export const transformDataIntoValueLabel = (data, labelKey, valueKey) => {
  return (
    data &&
    data.map((ix) => ({
      label: ix[labelKey],
      value: ix[valueKey],
    }))
  );
};
